import FavoriteIcon from "@mui/icons-material/Favorite";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Container,
  IconButton,
  TextField,
  Typography
} from "@mui/material";
import axios from "axios";
import debounce from "lodash.debounce";
import { SnackbarProvider } from "notistack";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useProducts } from "../contexts/ProductsContext";
import { useRecentSearches } from "../contexts/RecentSearchesContext.js";
import ProductCard from "./ProductCard.jsx";
import db from "./Products.database.js";
import BarCodeIcon from "./barcode.png";
import image from "./image.png";

// const PopularPrompts = memo(() => {
//   const navigate = useNavigate();
//   const [selectedChip, setSelectedChip] = useState(null);

//   const handleChipClick = (prompt) => {
//     setSelectedChip(prompt);
//     navigate(`/products/chat?prompt=${encodeURIComponent(prompt)}`);
//   };

//   return (
//     <Box sx={{ marginBottom: 3, marginTop: 3 }}>
//       <Typography
//         variant="h5"
//         sx={{ fontWeight: "bold", color: "#205375", textAlign: "left" }}
//       >
//         Popular{" "}
//         <span style={{ color: "#EF4F26", textAlign: "left" }}>Prompts?</span>
//       </Typography>
//       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, marginTop: 2 }}>
//         {[
//           "Zero Sugar",
//           "Classic Lemonade",
//           "Red Grapefruit",
//           "Cherry Pomegranate",
//           "Orange Tangerine",
//         ].map((prompt) => (
//           <Chip
//             key={prompt}
//             label={prompt}
//             onClick={() => handleChipClick(prompt)}
//             sx={{
//               backgroundColor:
//                 selectedChip === prompt
//                   ? (theme) => theme.palette.primary.main
//                   : undefined,
//               color: selectedChip === prompt ? "white" : undefined,
//             }}
//           />
//         ))}
//       </Box>
//     </Box>
//   );
// });

const DEBOUNCE_DELAY = 300;

const Products = () => {
  const { products } = db();
  const { saveItem } = useProducts();
  const { recentSearches } = useRecentSearches();
  const user = useSelector((state) => state.user);

  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const handleMouseOver = (index) => {
    setValue(index);
  };
  const debouncedSetSearch = useMemo(
    () =>
      debounce((newSearch) => {
        setDebouncedSearch(newSearch);
      }, DEBOUNCE_DELAY),
    []
  );
  useEffect(() => {
    debouncedSetSearch(search);
  }, [search, debouncedSetSearch]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleProductClick = useCallback(
    (product) => (e) => {
      e.preventDefault();
      navigate(`/products/details/${product.upc}`);
      saveItem(product);
    },
    [navigate, saveItem]
  );

  const fetchDemoData = async () => {
    try {
      const response = await axios.get(
        `https://api.upcitemdb.com/prod/trial/search?s=${search}&match_mode=1&type=product`
      );
      console.log(response.data.items);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    console.log("user: ", user);
    console.log(user.user, user.user.token)
    console.log("liked products: ", user.user.likedProducts);
  }, []);

  useEffect(() => {
    console.log("recent searches: ", recentSearches);
  }, []);
  return (
    <>
      <SnackbarProvider>
        <Container
          disableGutters
          maxWidth={false}
          sx={{
            paddingTop: {
              xs: 0,
              md: 2,
            },
            textAlign: "center",
            backgroundColor: "white",
            "@media (max-width: 768px)": { maxWidth: "xs" },
            "@media (min-width: 769px)": { maxWidth: "xl" },
          }}
        >

            <Box
              sx={{
                width: "100vw",
                height: "40vh",
                position: "relative",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  paddingBottom: "70px",
                  width: "100%",
                }}
              >
                {/* Fox Image (Appearing to Hold the Line) */}
                <Box
                  sx={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingBottom: "15px",
                    paddingTop:"25px"
                  }}
                >
                  <img
                    src="/middleLogo.svg" // Replace with the actual fox image path
                    alt="Fox Logo"
                    style={{
                      width: "100px", // Adjust size as needed
                      height: "auto",
                      position: "relative",
                      top: "10px",
                      zIndex: 2, // Ensures it's above the line
                      marginBottom: "-5px", // Moves the hands to align with the line
                    }}
                  />

                  {/* Gradient Line SVG */}
                  <svg width="100%" height="2" viewBox="0 0 804 2" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ maxWidth: "90vw" }} >
                    <line y1="1" x2="100%" y2="1" stroke="url(#paint0_linear_703_9726)" strokeWidth="2" />
                    <defs>
                      <linearGradient id="paint0_linear_703_9726" x1="0" y1="2.5" x2="804" y2="2.5" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#134A97" />
                        <stop offset="0.485" stopColor="#06142A" />
                        <stop offset="1" stopColor="#0B65B3" />
                      </linearGradient>
                    </defs>
                  </svg>
                </Box>

                {/* Text Under Logo */}
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 100,
                    color: "white",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "90%",
                    fontFamily: "Inter, sans-serif",
                    paddingTop: "5px",
                    fontSize: {
                      xs: "1.75rem",
                      sm: "2.25rem",
                      md: "2.75rem",
                      lg: "3.25rem",
                      xl: "3.75rem",
                    },
                  }}
                >
                  Thinking about a Product
                </Typography>
              </Box>



                <TextField
                  value={search}
                  onChange={handleSearchChange}
                  onKeyDown={(e) =>
                    e.key === "Enter" && search.trim() !== "" && navigate(`/products/details/${search}`)
                  }
                  variant="outlined"
                  placeholder="Search by product name or UPC"
                  sx={{
                    width: { xs: "85%", sm: "60%", md: "65%", lg: "70%" }, 
                    borderRadius: "50px",
                    marginTop: "-25px",
                    height: "1px",
                    "& .MuiOutlinedInput-root": {
                      padding: "8px",
                      borderRadius: "50px", // Makes the input field circular
                      "& fieldset": {
                        borderRadius: "50px", // Ensures the border is rounded
                      },
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <Box sx={{ display: "flex", gap:"15px"}}>
                       <IconButton 
                          onClick={() => {
                            if (search.trim() !== "") {
                              navigate(`/products/details/${search}`);
                            }
                          }}
                        >
                          <SearchIcon />
                        </IconButton>

                        <IconButton
                          onClick={() => navigate("/scannerTest")}
                          sx={{ width: "40px", height: "40px", paddingRight:"30px"  }}
                        >
                          <img
                            src={BarCodeIcon}
                            alt="Barcode Icon"
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.nextSibling.style.display =
                                "inline-block";
                            }}
                          />
                        </IconButton>
                        {/* <IconButton
                          onClick={() => navigate(`/camera`)}
                          sx={{ width: "60px", height: "60px" }}
                        >
                          <img
                            src={CameraIcon}
                            alt="Camera Icon"
                            sx={{ width: "60px", height: "60px" }}
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.nextSibling.style.display =
                                "inline-block";
                            }}
                          />
                        </IconButton> */}
                      </Box>
                    ),
                    inputProps: {
                      style: { fontSize: "1rem", padding: "10px 15px" }, // Adjusted padding for better fit
                    },
                  }}
                />
              </Box>
    

            {/* start of buttons
          <Grid
            container
            justifyContent="center"
            sx={{ display: "flex", gap: 2 }}
          >
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  navigate("/scanner");
                }}
                sx={{
                  height: "7vh",
                  "@media (max-width: 768px)": {
                    maxWidth: "19vh",
                  },
                  "@media (min-width: 769px)": {
                    maxWidth: "20vh",
                  },
                  "@media (max-height: 730px)": {
                    maxWidth: "22vh",
                  },
                  padding: 2,
                  textTransform: "none",
                  borderColor: "#E1F5FE",
                  color: "#000",
                  backgroundColor: "#E1F5FE",
                  "&:hover": {
                    borderColor: "#81D4FA",
                    backgroundColor: "#B3E5FC",
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
               
                <Box
                  component="span"
                  sx={{ display: "inline-flex", alignItems: "center" }}
                >
                  <img
                    src="./barcode.png"
                    alt="Barcode Icon"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "inline-block";
                    }}
                  />
                  <BarcodeIcon
                    sx={{ marginRight: 1, color: "grey", display: "none" }}
                  />
                </Box>
 
                <div>
                  <Typography
                    variant="body2"
                    component="span"
                    sx={{ color: "#555555", marginRight: 0.5 }}
                  >
                    Scan with
                  </Typography>
                  {"\n"}
                  <Typography
                    component="span"
                    sx={{ color: "#205375", fontWeight: "bold" }}
                  >
                    Barcode
                  </Typography>
                </div>
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  navigate("/camera");
                }}
                sx={{
                  height: "7vh",
                  "@media (max-width: 768px)": {
                    maxWidth: "19vh",
                  },
                  "@media (min-width: 769px)": {
                    maxWidth: "20vh",
                  },
                  "@media (max-height: 730px)": {
                    maxWidth: "22vh",
                  },
                  padding: 2,
                  textTransform: "none",
                  borderColor: "#E1F5FE",
                  color: "#000",
                  backgroundColor: "white",
                  "&:hover": {
                    borderColor: "#81D4FA",
                    backgroundColor: "#B3E5FC",
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="span"
                  sx={{ display: "inline-flex", alignItems: "center" }}
                >
                  <img
                    src="./camera.png"
                    alt="Camera icon"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "inline-block";
                    }}
                  />
                  <CameraIcon
                    sx={{ marginRight: 1, color: "grey", display: "none" }}
                  />
                </Box>
                <div>
                  <Typography
                    variant="body2"
                    component="span"
                    sx={{ color: "#555555", marginRight: 0.5 }}
                  >
                    Scan with
                  </Typography>
                  {"\n"}
                  <Typography
                    component="span"
                    sx={{ color: "#205373", fontWeight: "bold" }}
                  >
                    Camera
                  </Typography>
                </div>
              </Button>
            </Grid>
          </Grid>
          end of buttons */}

            {/* <Box sx={{ marginTop: 3, marginBottom: 3 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "#205375",
                textAlign: "left",
                marginBottom: 2,
              }}
            >
              Recent{" "}
              <span style={{ color: "#EF4F26", textAlign: "left" }}>
                Searches
              </span>
            </Typography>
            <Tabs
              variant="scrollable"
              value={value}
              onChange={(newValue) => setValue(newValue)}
            >
              {productDetails.map((card, value) => (
                <Tab
                  key={value}
                  label={
                    <ProductCard
                      image={card.image}
                      title={card.title}
                      height={70}
                    />
                  }
                  onClick={handleProductClick(card)}
                  onMouseOver={() => handleMouseOver(value)}
                  sx={{
                    fontWeight: "bold",
                    borderRadius: "3vh",
                  }}
                />
              ))}
            </Tabs>
          </Box> */}
            <Box p={2} backgroundColor="white" sx={{px: { xs: "40px", sm: "40px", md: "130px" }}}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: "#205375",
                  textAlign: "left",
                  marginTop: 3,
                }}
              >
                Your{" "}
                <span style={{ color: "#EF4F26", textAlign: "left" }}>
                  Searches
                </span>
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 1,
                  marginBottom: 3,
                  padding: 1,
                  overflow: "auto",
                }}
              >
                {recentSearches ? (
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {recentSearches.map((info, index) => (
                      <Box
                        key={index}
                        sx={{ flexShrink: 0, width: "17vh", marginRight: 2 }}
                        onClick={handleProductClick(info)}
                      >
                        <ProductCard
                          image={info.image}
                          title={info.name}
                          height={"27vh"}
                          upc={info.upc}
                        />
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Box></Box>
                )}
                <Box>
                  {recentSearches.length < 1 && (
                    <Box>
                      You don't have any recent searches yet. Start typing!
                    </Box>
                  )}
                </Box>
              </Box>

              {/* if the tabs doesnt work, use this code instead */}

              {/* Popular Products section */}

              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: "#205375",
                  textAlign: "left",
                  marginTop: 2,
                }}
              >
                Popular{" "}
                <span style={{ color: "#EF4F26", textAlign: "left" }}>
                  Products
                </span>
              </Typography>

              {/* <Box sx={{ marginBottom: 5, marginTop: 3 }} >
                <Grid container spacing={2} size={{ lg: 12 }}>
                  {products.map((info, index) => (
                    <Grid
                      item
                      xs={4}
                      sm={3}
                      md={2}
                      lg={1.5}
                      key={index}
                      onClick={handleProductClick(info)}
                    >
                      <ProductCard
                        image={info.image}
                        title={info.name}
                        height={"30vh"}
                        maxHeight={120}
                        upc={info.upc}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box> */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 1,
                  marginBottom: 3,
                  padding: 1,
                  overflow: "auto",
                }}
              >
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                    {products.map((info, index) => (
                      <Box
                        key={index}
                        sx={{ flexShrink: 0, width: "17vh", marginRight: 2 }}
                        onClick={handleProductClick(info)}
                      >
                        <ProductCard
                          image={info.image}
                          title={info.name}
                          height={"27vh"}
                          upc={info.upc}
                        />
                      </Box>
                    ))}
                  </Box>
              </Box>

            </Box>

          {/* <PopularPrompts /> */}
          <Box sx={{ minBlockSize: "5vh" }} />
        </Container>
        <Box
          sx={{
            backgroundColor: "#EF4F26",
            borderRadius: 10,
            position: "absolute",
            bottom: { xs: "3vh", sm: "3vh", md: "5vh", lg: "5vh" },
            right: { xs: "3vh", sm: "3vh", md: "5vh", lg: "5vh" },
            "&:hover": {
              transform: "scale(1.35)",
              transition: "all 0.3s ease-in-out",
            },
            "&:not(:hover)": {
              transform: "scale(1)",
              transition: "all 0.3s ease-in-out",
            },
          }}
        >
          {user.user  && user.user.token && (
            <IconButton onClick={() => navigate("/products/likes")}>
              <FavoriteIcon sx={{ color: "white" }} />
            </IconButton>
          )}

        </Box>
        {/* <AppBar
        position="fixed"
        sx={{ backgroundColor: "white", top: "auto", bottom: 0 }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mr: 2,
            ml: 2,
          }}
        >
          <IconButton>
            <StarIcon sx={{ color: "#EF4F26" }} />
          </IconButton>
          <IconButton>
            <HomeIcon sx={{ color: "#EF4F26" }} />
          </IconButton>
          <IconButton onClick={() => navigate("/products/likes")}>
            <FavoriteIcon sx={{ color: "#EF4F26" }} />
          </IconButton>
        </Toolbar>
      </AppBar> */}
      </SnackbarProvider>
    </>
  );
};

export default Products;
